module.exports = __webpack_public_path__ + "media/theme/icon-response-47660957.png";